<template>
	<div class="container">
		<div class="section-wrapper top-wrapper">
			<div>
				<mt-field
						class="input-wrapper"
					v-model="username"
					placeholder="Username"
					maxlength="25"
				/>
			</div>
		</div>
		<label class="tips">User name is 3-25 digits, can include English and numbers</label>
		<div class="section-wrapper bottom-wrapper">
			<mt-field v-if="config.captcha_status_register=='1'" class="input-wrapper" v-model="pictureCode" placeholder="Please enter the image verification code" maxlength="6">
				<img @click="changePictureCode" :src="pictureCodeUrl" class="countdown" >
			</mt-field>
			<div>
				<mt-field
					type="password"
					class="input-wrapper"
					v-model="password"
					placeholder="Set password"
					maxlength="20"
				/>
			</div>
			<div>
				<mt-field
					type="password"
					class="input-wrapper"
					v-model="confirmPassword"
					placeholder="Confirm password"
					maxlength="20"
				/>
			</div>
		</div>
		<label class="tips">6-20 digits/letters/symbols</label>

		<mt-button class="ds-button-large mt-10 mb-10" type="primary" v-on:click="onSubmit">Registered</mt-button>
		<div class="link-wrapper">
			<span class="left-text">Click sign up to agree</span>
			<span class="right-text" @click="onAgreement">"User Agreement"</span>
		</div>
	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { register } from '../../../api/memberRegister'
import { getSmsCaptcha, checkPictureCaptcha } from '../../../api/common'
export default {
  name: 'RegisterByEmail',
  data () {
    return {
      pictureCodeUrl: '',
      pictureCode: '',
      pictureCodeValid: false,
      pictureCodeWait: false,
      username: '',
      password: '',
      confirmPassword: '',
      aggrementUrl: ''
    }
  },
  created: function () {
	  this.fetchConfig({}).then(
			  response => {
			  },
			  error => {
				  Toast(error.message)
			  }
	  )
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId,
      config: state => state.config.config
    })
  },
  mounted () {
    this.changePictureCode()
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
	  ...mapActions({
		  fetchConfig: 'fetchConfig'
	  }),
	  changePictureCode () {
		  this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
	  },
    goBack () {
      this.$router.go(-1)
    },
    goProfile () {
      this.$router.go(-2)
    },
    goProfileAdd () {
      this.$router.push({ name: 'profileAdd' })
    },
    check () {
      let username = this.username
      let password = this.password
      let confirmPassword = this.confirmPassword
      if (username.length === 0) {
        Toast('Please enter a username of 3-25 characters')
        return false
      }
      if (username.length < 3 || username.length > 25) {
        Toast('Please enter a username of 3-25 characters')
        return false
      }
      if (password.length === 0) {
        Toast('Please enter the password')
        return false
      }
      if (password.length < 6 || password.length > 20) {
        Toast('Please enter a password of 6-20 characters')
        return false
      }
      if (confirmPassword.length === 0) {
        Toast('Please enter confirm password')
        return false
      }
      if (password.length !== confirmPassword.length) {
        Toast('Confirm the password is inconsistent with the entered password')
        return false
      }
      if (password !== confirmPassword) {
        Toast('Confirm the password is inconsistent with the entered password')
        return false
      }

      return true
    },
    signup () {
      if (!this.check()) {
        return
      }
      Indicator.open()
      let inviterId = this.inviter_id // 获取邀请人id
      register(this.username, this.password, this.confirmPassword, inviterId, this.pictureCode).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit () {
      this.signup()
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	//background-color: #e93b3d;
	.section-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #ffffff;
		border-top: 1px solid #e8eaed;
		border-bottom: 1px solid #e8eaed;
		.input-wrapper {
			font-size: .7rem;
			display: flex;
			flex-direction: row;
			align-content: flex-start;
			align-items: center;
			background-color: #fff;
			height:2.2rem;
			padding-left:0.5rem;
			img {
				height: 1.75rem;width: auto;
				margin: 0;
				padding: 0;
			}
			input {
				flex: 1;
			}
			.bottom-input {
				border-bottom-width: 0;
			}
		}
	}
	.link-wrapper {
		height:2.2rem;
		margin-top:0.5rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: stretch;
		span {
			font-size:0.7rem;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}
		.left-text {
			color: #c3c3c3;
		}
		.right-text {
			color: $primaryColor;
		}
	}
}
.top-wrapper {
	margin-top:0.5rem;
}
.bottom-wrapper {
	margin-top:0.5rem;
}
.tips {
	color: #c3c3c3;
	font-size:0.6rem;
	margin-left: 0.9rem;
	margin-top:0.5rem;
	text-align: left;
}
.countdown {min-width:4rem;margin-right:0.5rem;}
</style>
